import { Box, Divider } from "@mui/material";
import React from "react";

interface FilterSectionProps {
  children: React.ReactNode;
  showDivider?: boolean;
  marginBottom?: number;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  children,
  showDivider = false,
  marginBottom = 3,
}) => {
  return (
    <>
      <Box sx={{ mb: marginBottom }}>{children}</Box>
      {showDivider && <Divider sx={{ my: 3 }} />}
    </>
  );
};

export default FilterSection;
